let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fjNHB")).then(() => parcelRequire('34tgh'));